import _toConsumableArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { useInView } from 'react-intersection-observer';
import ResizeObserver from 'resize-observer-polyfill';
import { DEFAULT_RENDER_DELAY } from "../banner/constants";
import { getTargetedBanners } from "./utils";
export var BANNER_STORAGE_ID = 'dismissedBanners';
export var useBanner = function useBanner(props) {
  var getBannerEvents = props.bannerEvents,
    banners = props.banners,
    audiencesConfig = props.audiencesConfig,
    onShow = props.onShow;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    bannerElement = _useState2[0],
    setBannerElement = _useState2[1];
  var setBannerRef = useCallback(function (node) {
    if (node !== null) {
      setBannerElement(node);
    }
  }, []);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasShown = _useState4[0],
    setHasShown = _useState4[1];
  var _useLocalStorage = useLocalStorage(BANNER_STORAGE_ID, []),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    dismissedBanners = _useLocalStorage2[0],
    setDismissedBanners = _useLocalStorage2[1];
  var targetedBanners = useMemo(function () {
    return getTargetedBanners(banners, audiencesConfig);
  }, [banners, audiencesConfig]);
  var activeBanner = useActiveBanner(targetedBanners, dismissedBanners);
  var bannerHeight = useBannerHeight(activeBanner, bannerElement);
  var bannerEvents = useMemo(function () {
    return _objectSpread({
      click: function click() {},
      dismiss: function dismiss() {},
      show: function show() {}
    }, getBannerEvents(activeBanner));
  }, [activeBanner, getBannerEvents]);
  var cta = useMemo(function () {
    return getCta(activeBanner, bannerEvents === null || bannerEvents === void 0 ? void 0 : bannerEvents.click);
  }, [activeBanner, bannerEvents]);
  var handleDismiss = activeBanner ? function () {
    var bannerKey = getBannerKey(activeBanner);
    setDismissedBanners([].concat(_toConsumableArray(dismissedBanners), [bannerKey]));
    bannerEvents.dismiss();
  } : null;
  useEffect(function () {
    if (!activeBanner || hasShown) return;
    onShow && activeBanner && onShow(activeBanner);
    setHasShown(true);
    bannerEvents.show();
  }, [activeBanner, bannerEvents, hasShown, onShow]);
  return {
    activeBanner: activeBanner,
    bannerHeight: bannerHeight,
    setBannerRef: setBannerRef,
    cta: cta,
    handleDismiss: handleDismiss,
    hasActiveBanner: Boolean(activeBanner),
    targetedBanners: targetedBanners
  };
};
var ESTIMATED_BANNER_HEIGHT = 72;
var useBannerHeight = function useBannerHeight(activeBanner, bannerElement) {
  var _useState5 = useState(
    // If a non-dismissible banner is shown, then we initially set an estimated banner height
    // so that the mega-menu position is correct when the page is server-side rendered
    activeBanner ? ESTIMATED_BANNER_HEIGHT : 0),
    _useState6 = _slicedToArray(_useState5, 2),
    bannerHeight = _useState6[0],
    setBannerHeight = _useState6[1];
  var _useInView = useInView({
      threshold: 1,
      initialInView: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    inViewRef = _useInView2[0],
    inView = _useInView2[1];
  useEffect(function () {
    if (!bannerElement) {
      return;
    }
    inViewRef(bannerElement);
  }, [inViewRef, bannerElement]);
  useEffect(function () {
    if (!bannerElement) {
      return;
    }
    var resizeObserver = new ResizeObserver(function (entries) {
      var isEntriesIterable = (Symbol.iterator in Object(entries));
      if (!isEntriesIterable) {
        return;
      }
      var newBannerHeight;
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          var _entry$borderBoxSize;
          newBannerHeight = ((_entry$borderBoxSize = entry.borderBoxSize) === null || _entry$borderBoxSize === void 0 ? void 0 : _entry$borderBoxSize.length) > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      setBannerHeight(newBannerHeight || 0);
    });
    resizeObserver.observe(bannerElement);
    return function () {
      resizeObserver.unobserve(bannerElement);
    };
  }, [bannerElement]);
  if (!activeBanner || !inView) return 0;
  return bannerHeight;
};
var useActiveBanner = function useActiveBanner(banners, dismissedBanners) {
  var bannersNotDismissible = banners.every(function (banner) {
    return banner.dismissible === false;
  });
  var initialBanner = bannersNotDismissible ? getActiveBanner(banners, dismissedBanners) : null;
  var delayedBanners = useRef([]);
  var _useState7 = useState(initialBanner),
    _useState8 = _slicedToArray(_useState7, 2),
    activeBanner = _useState8[0],
    setActiveBanner = _useState8[1];
  var setBanner = useCallback(function (banners, dismissedBanners, delayedBanners) {
    var banner = getActiveBanner(banners, dismissedBanners);
    if (banner) {
      var bannerKey = getBannerKey(banner);
      var _banner$renderDelay = banner.renderDelay,
        renderDelay = _banner$renderDelay === void 0 ? DEFAULT_RENDER_DELAY : _banner$renderDelay;

      // Banner appearance already delayed
      if (delayedBanners.current.includes(bannerKey)) return;

      // Banner appearance needs to be delayed
      if (renderDelay > 0 && !delayedBanners.current.includes(bannerKey)) {
        delayedBanners.current.push(bannerKey);
        setTimeout(function () {
          setActiveBanner(banner);
        }, renderDelay * 1000);
        setActiveBanner(null);
        return;
      }
      setActiveBanner(banner);
      return;
    }
    setActiveBanner(null);
  }, []);

  // This useEffect ensures that we only set the active banner on the client.
  // dismissedBanners is only accurate client-side.
  useEffect(function () {
    setBanner(banners, dismissedBanners, delayedBanners);
  }, [banners, dismissedBanners, delayedBanners, setBanner]);
  return activeBanner;
};
var getActiveBanner = function getActiveBanner(banners, dismissedBanners) {
  return banners.find(function (banner) {
    var bannerKey = getBannerKey(banner);
    return !dismissedBanners.includes(bannerKey);
  });
};
var getCta = function getCta(activeBanner, onClick) {
  if (!activeBanner) return;
  return _objectSpread(_objectSpread({}, activeBanner.cta), {}, {
    onClick: onClick
  });
};
var getBannerKey = function getBannerKey(banner) {
  return (banner.name || '').toLowerCase().replace(' ', '-');
};